import { EmailInput } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { useBrandingRepository } from '@frontend/repository';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import defaultLogo from '../../../../assets/images/telloport_logo_horizontal.png';
import useForgotPassword from './forgot-password.controller';

const ID = 'forgot-password';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const viewProps = useForgotPassword();
    const { logo_navbar_expanded } = useBrandingRepository();

    const logo = useMemo(() => {
        if (logo_navbar_expanded) return logo_navbar_expanded;
        return defaultLogo;
    }, [logo_navbar_expanded]);
    return (
        <div
            id={ID}
            className='relative flex h-screen w-screen flex-col'>
            <div className='bg-brand-structure absolute top-0 right-0 left-0 -z-1 h-[40vh] w-full'></div>
            <form className='bg-always-white mx-auto my-40 h-1/2 w-1/2 rounded-lg shadow-lg'>
                <div className='flex h-1/3 flex-col justify-center p-3 align-middle'>
                    <img
                        src={logo}
                        className='img-fluid m-auto w-30'
                    />
                    <h1 className='text-brand-primary m-auto text-4xl font-black'>
                        <FormattedMessage
                            id='forgot-password.title'
                            description='Title for the forgot password page.'
                            defaultMessage='Forgot password'
                        />
                    </h1>

                    <div className='text-always-black flex h-1/2 w-full flex-col content-center items-center p-4 text-sm'>
                        <span>
                            <FormattedMessage
                                id='forgot-password.description'
                                description='Description for the forgot password page.'
                                defaultMessage="Enter your email address and we'll send you a link to reset your password."
                            />
                        </span>
                        <span>
                            <FormattedMessage
                                id='forgot-password.description2'
                                description='Description for the forgot password page.'
                                defaultMessage='If you do not receive an email, please check your spam folder.'
                            />
                        </span>
                    </div>
                </div>

                <div className='flex h-1/3 w-full flex-col content-center items-center justify-center p-4'>
                    <EmailInput
                        required
                        label='Email'
                        errorMessage='Please fill in a valid email.'
                        autoFocus
                        value={viewProps.formValues.email}
                        onChange={(value) => viewProps.changeFormValues({ ...viewProps.formValues, email: value })}
                        isValidCallback={(value) => {
                            if (viewProps.submitted) viewProps.changeEmailValid(value);
                        }}
                        submitted={viewProps.submitted}
                        valid={viewProps.emailValid}
                        noConditionedStyling
                    />
                </div>

                <div className='flex h-1/3 w-full flex-col items-center justify-end gap-3 pb-4'>
                    <button
                        id='submit-button'
                        type='button'
                        className='btn bg-brand-primary w-1/3'
                        disabled={!viewProps.emailValid}
                        onClick={viewProps.onSubmit}
                        data-testid='submitButton'>
                        <div className='text-always-white justify-start text-base font-medium'>{CommonMessage.BUTTONS.SUBMIT}</div>
                    </button>
                    <span
                        id='back-button'
                        className='text-brand-primary cursor-pointer font-medium'
                        onClick={() => navigate('/admin/')}
                        data-testid='backButton'>
                        {CommonMessage.BUTTONS.BACK}
                    </span>
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;
